import Breadcrumbs from '@Components/Breadcrumbs';
import Heading from '@Components/Heading';
import { PromoCodeList } from '@Components/PromoCodes';

export default function PromoCodes() {
  return (
    <div>
      <Breadcrumbs
        navList={[
          { name: 'Admin', href: '/' },
          { name: 'Promo Codes', href: '/promo-codes' },
        ]}
      />
      <div className="mt-8 mb-4 flex items-center justify-between">
        <div>
          <Heading>Promo Codes</Heading>
        </div>
      </div>
      <PromoCodeList />
    </div>
  );
}
